import { default as editJF9WT6mq99Meta } from "/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/[sub_page]/edit.vue?macro=true";
import { default as index4djZ0zvnMdMeta } from "/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/[sub_page]/index.vue?macro=true";
import { default as createBTNIpS3tH3Meta } from "/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/create.vue?macro=true";
import { default as editHIWcIaye56Meta } from "/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/edit.vue?macro=true";
import { default as indexg4iDU1QvpvMeta } from "/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/index.vue?macro=true";
import { default as createvy0ndo3wTOMeta } from "/home/runner/work/guide/guide/src/pages/[area]/[section]/create.vue?macro=true";
import { default as _91section_93zdYYLzwtXSMeta } from "/home/runner/work/guide/guide/src/pages/[area]/[section].vue?macro=true";
import { default as _91item_93bjJaU6g6JqMeta } from "/home/runner/work/guide/guide/src/pages/[area]/changes/[item].vue?macro=true";
import { default as indexeM4iei0SYvMeta } from "/home/runner/work/guide/guide/src/pages/[area]/changes/index.vue?macro=true";
import { default as faqwZiE258pRLMeta } from "/home/runner/work/guide/guide/src/pages/[area]/faq.vue?macro=true";
import { default as indexXMNPq6EdrSMeta } from "/home/runner/work/guide/guide/src/pages/[area]/index.vue?macro=true";
import { default as _91area_93r6Ijv7Zi02Meta } from "/home/runner/work/guide/guide/src/pages/[area].vue?macro=true";
import { default as indexCXyDnJDDSpMeta } from "/home/runner/work/guide/guide/src/pages/index.vue?macro=true";
export default [
  {
    name: _91area_93r6Ijv7Zi02Meta?.name ?? undefined,
    path: _91area_93r6Ijv7Zi02Meta?.path ?? "/:area()",
    meta: _91area_93r6Ijv7Zi02Meta || {},
    alias: _91area_93r6Ijv7Zi02Meta?.alias || [],
    redirect: _91area_93r6Ijv7Zi02Meta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area].vue").then(m => m.default || m),
    children: [
  {
    name: _91section_93zdYYLzwtXSMeta?.name ?? "area-section___de",
    path: _91section_93zdYYLzwtXSMeta?.path ?? ":section()",
    meta: _91section_93zdYYLzwtXSMeta || {},
    alias: _91section_93zdYYLzwtXSMeta?.alias || [],
    redirect: _91section_93zdYYLzwtXSMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/[section].vue").then(m => m.default || m),
    children: [
  {
    name: editJF9WT6mq99Meta?.name ?? "area-section-page-sub_page-edit___de",
    path: editJF9WT6mq99Meta?.path ?? ":page()/:sub_page()/edit",
    meta: editJF9WT6mq99Meta || {},
    alias: editJF9WT6mq99Meta?.alias || [],
    redirect: editJF9WT6mq99Meta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/[sub_page]/edit.vue").then(m => m.default || m)
  },
  {
    name: index4djZ0zvnMdMeta?.name ?? "area-section-page-sub_page___de",
    path: index4djZ0zvnMdMeta?.path ?? ":page()/:sub_page()",
    meta: index4djZ0zvnMdMeta || {},
    alias: index4djZ0zvnMdMeta?.alias || [],
    redirect: index4djZ0zvnMdMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/[sub_page]/index.vue").then(m => m.default || m)
  },
  {
    name: createBTNIpS3tH3Meta?.name ?? "area-section-page-create___de",
    path: createBTNIpS3tH3Meta?.path ?? ":page()/create",
    meta: createBTNIpS3tH3Meta || {},
    alias: createBTNIpS3tH3Meta?.alias || [],
    redirect: createBTNIpS3tH3Meta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/create.vue").then(m => m.default || m)
  },
  {
    name: editHIWcIaye56Meta?.name ?? "area-section-page-edit___de",
    path: editHIWcIaye56Meta?.path ?? ":page()/edit",
    meta: editHIWcIaye56Meta || {},
    alias: editHIWcIaye56Meta?.alias || [],
    redirect: editHIWcIaye56Meta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/edit.vue").then(m => m.default || m)
  },
  {
    name: indexg4iDU1QvpvMeta?.name ?? "area-section-page___de",
    path: indexg4iDU1QvpvMeta?.path ?? ":page()",
    meta: indexg4iDU1QvpvMeta || {},
    alias: indexg4iDU1QvpvMeta?.alias || [],
    redirect: indexg4iDU1QvpvMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/[section]/[page]/index.vue").then(m => m.default || m)
  },
  {
    name: createvy0ndo3wTOMeta?.name ?? "area-section-create___de",
    path: createvy0ndo3wTOMeta?.path ?? "create",
    meta: createvy0ndo3wTOMeta || {},
    alias: createvy0ndo3wTOMeta?.alias || [],
    redirect: createvy0ndo3wTOMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/[section]/create.vue").then(m => m.default || m)
  }
]
  },
  {
    name: _91item_93bjJaU6g6JqMeta?.name ?? "area-changes-item___de",
    path: _91item_93bjJaU6g6JqMeta?.path ?? "changes/:item()",
    meta: _91item_93bjJaU6g6JqMeta || {},
    alias: _91item_93bjJaU6g6JqMeta?.alias || [],
    redirect: _91item_93bjJaU6g6JqMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/changes/[item].vue").then(m => m.default || m)
  },
  {
    name: indexeM4iei0SYvMeta?.name ?? "area-changes___de",
    path: indexeM4iei0SYvMeta?.path ?? "changes",
    meta: indexeM4iei0SYvMeta || {},
    alias: indexeM4iei0SYvMeta?.alias || [],
    redirect: indexeM4iei0SYvMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/changes/index.vue").then(m => m.default || m)
  },
  {
    name: faqwZiE258pRLMeta?.name ?? "area-faq___de",
    path: faqwZiE258pRLMeta?.path ?? "faq",
    meta: faqwZiE258pRLMeta || {},
    alias: faqwZiE258pRLMeta?.alias || [],
    redirect: faqwZiE258pRLMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/faq.vue").then(m => m.default || m)
  },
  {
    name: indexXMNPq6EdrSMeta?.name ?? "area___de",
    path: indexXMNPq6EdrSMeta?.path ?? "",
    meta: indexXMNPq6EdrSMeta || {},
    alias: indexXMNPq6EdrSMeta?.alias || [],
    redirect: indexXMNPq6EdrSMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/[area]/index.vue").then(m => m.default || m)
  }
]
  },
  {
    name: indexCXyDnJDDSpMeta?.name ?? "index___de",
    path: indexCXyDnJDDSpMeta?.path ?? "/",
    meta: indexCXyDnJDDSpMeta || {},
    alias: indexCXyDnJDDSpMeta?.alias || [],
    redirect: indexCXyDnJDDSpMeta?.redirect,
    component: () => import("/home/runner/work/guide/guide/src/pages/index.vue").then(m => m.default || m)
  }
]